<template>
  <v-container class="fill-height">
    <v-row>
      <v-col />
      <v-col
        cols="12"
        sm="6"
        md="5"
        lg="4"
        class="d-flex justify-center align-center pa-5"
      >
        <v-card
          flat
          class="bcolor-transparent rounded-0"
        >
          <v-card-title>
            <div class="text-h3">
              Восстановление пароля
            </div>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="login"
              v-mask="'+7(###)##-###-##'"
              prepend-icon="mdi-phone-classic"
              background-color="white"
              filled
              :disabled="show"
              label="Номер телефона или email"
              :rules="phoneRules"
            />
            <v-text-field
              v-if="show"
              v-model="confirmCode"
              background-color="white"
              filled
              prepend-icon="mdi-numeric"
              label="Код из СМС"
              required
            />
            <v-text-field
              v-if="show"
              v-model="password"
              prepend-icon="mdi-lock"
              background-color="white"
              filled
              required
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules="passwordRules"
              label="Пароль"
              @click:append="showPassword = !showPassword"
            />
            <v-text-field
              v-if="show"
              v-model="password2"
              prepend-icon="mdi-lock"
              background-color="white"
              filled
              required
              :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword2 ? 'text' : 'password'"
              :rules="passwordRules"
              label="Повторить пароль"
              @click:append="showPassword2 = !showPassword2"
            />
            <v-row v-if="alert.show">
              <v-col
                cols="12"
              >
                <div
                  style="color: red; text-align: center"
                >
                  {{ alert.error }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-column">
            <v-btn
              color="blue lighten-4"
              text
              @click="onRepeat"
            >
              Повторить
            </v-btn>
            <v-btn
              :disabled="show ? (confirmCode.length !== 6 || (password != password2 || password.length <= 5)) : false"
              class="flex-grow-1 flex-shrink-0"
              color="primary"
              @click="show ? onSendPassword() : onSendSms()"
            >
              {{ show ? 'Сменить' : 'Отправиить СМС' }}
            </v-btn>
            <v-btn
              color="blue lighten-4"
              text
              @click="$router.push({name: 'LoginLoyaltyLink'})"
            >
              Авторизация
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { TheMask } from "vue-the-mask"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { isNotExists } from "@/views/loyalty/shared/modules/utilities"

export default {
  name: "RecoverLoyalty",
  components: { TheMask },
  data: () => ({
    alert: {
      show: false,
      error: '',
    },
    confirmCode: '',
    login: '',
    reg_got_code: null,
    password: '',
    password2: '',
    passwordRules: [
      v => !!v || 'Пароль обязателен',
      v => (v && v.length >= 6) || 'Пароль должен содержать, не менее 6 символов',
    ],
    phoneRules: [
      v => !!v || 'Номер телефона обязателен',
      v => (v && v.length >= 12) || 'Номер телефона должен содержать, не менее 12 символов',
    ],
    show: false,
    showPassword: false,
    showPassword2: false,
    webApi: null
  }),
  beforeMount () {
    this.webApi = new WebApi(this.$store).editError('Произошла ошибка при смене пароля')
  },
  methods: {
    getRouteName (obj) {
      if (!isNotExists(obj.email) && !isNotExists(obj.name) && !isNotExists(obj.surname)) {
        if (obj.email.length > 0 && obj.name.length > 0 && obj.surname.length > 0) {
          return 'Crowd'
        } else {
          return 'CrowdProfile'
        }
      }
    },
    onRepeat () {
      this.show = false
      this.reg_got_code = null
    },
    onSendSms () {
      if (this.login.length > 12) {
        this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/confirm_code/recover/`, { phone: this.login }).then((response) => {
          console.log('response', response)
          this.reg_got_code = response
          this.show = true
        })
      }
    },
    onSendPassword () {
      console.log('Send Password')
      if (this.reg_got_code == this.confirmCode) {
        this.alert.show = false
        console.log('password going to sent')
        this.webApi.put(`${process.env.VUE_APP_LOYALTY_URL}api/user_profile/recover/${this.login}/${this.password}`).then(response => {
          if (response.status_code === 200) {
            console.log('password is changed')
            this.webApi.put(`${process.env.VUE_APP_LOYALTY_URL}api/login/`, { phoneNumber: this.login, password: this.password, password2: this.password }).then((response) => {
              console.log('***Success!***')
              console.log('response', response.data)
              this.$store.dispatch('userProfile_store/updateUserProfile', response.data)
              localStock.setItem('userProfile', response.data)
              localStorage.setItem('userProfileId', response.data.userProfileId)
              localStorage.removeItem('client')
              localStorage.setItem('login', response.data.login)
              localStorage.setItem('token', response.data.token)
              this.$router.push({ name: this.getRouteName(response.data) })
            })
          }
            }
        )
      } else {
        this.alert.show = true
        this.alert.error = 'Неверный СМС код'
      }
    }
  }
}
</script>

<style scoped>
.bcolor-transparent {
    background-image: url("/background-friday-gift.png");
    background-size: cover;
    color: white;
    border-radius: 0;
}

</style>
